export const AppConst = {
    LIVE: true,
    APP_NAME: 'Payswitch',
    APP_YEAR: (new Date()).getFullYear(),
    MALE: 1,
    FEMALE: 2,
    PAGINATION_PER_PAGE: 30,
    MIN_TOP_UP_AMOUNT: 1000
};
